import { PageNotFound, Notice, Privacy, Terms, FAQs, Contact, Main, Checkout, About, B2B, Login, Shop, ProductPage } from "../pages";

export const routes = [
  { path: "/about", component: About },
  { path: "/legal-notice", component: Notice },
  { path: "/privacy", component: Privacy },
  { path: "/terms", component: Terms },
  { path: "/faqs", component: FAQs },
  { path: "/contact", component: Contact },
  { path: "/checkout", component: Checkout },
  { path: "/b2b", component: B2B },
  { path: "/login", component: Login },
  { path: "/shop", component: Shop },
  { path: "/product/:productId", component: ProductPage },
  { path: "/", component: Main },
  { path: "/*", component: PageNotFound },
];